<template>
    <transition name="scale">
        <div class="f-alert" v-show="show">
            <div class="alert">
                {{notice}}
            </div>
        </div>
    </transition>
</template>

<script>

    export default {
        name: "FAlert",
        data() {
            return {
                notice: '一些提示消息',
                show: false
            }
        },
        mounted() {
            this.bus.$on('notice', function (res, time) {
                let timeout = time ? time : 1500;
                this.notice = res;
                this.show = true;
                setTimeout(() => {
                    this.show = false
                }, timeout)
            }.bind(this))
        }
    }
</script>

<style scoped>
    .f-alert {
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
        left: 0;
        pointer-events: none;
        position: fixed;
        top: 0;
        transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
        width: 100%;
        z-index: 6;
        background-color: rgba(33, 33, 33, .2);
        outline: none;
    }

    .alert {
        padding: 20px;
        box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
        border-radius: 6px;
        margin: 24px;
        text-align: center;
        font-size: 16px;
        background-color: white;
        overflow-y: auto;
        pointer-events: auto;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        z-index: inherit;
    }
    .scale-enter-active .alert, .scale-leave-active .alert{
        transition: all  .3s;
    }
    .scale-enter .alert, .scale-leave-to .alert{
        opacity: 0;
        transform: scale(0.5);
    }
</style>